import React from "react";
import Framework from "./Framework";
import Language from "./Language";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: 100,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "tween",
      delay: 0.7,
      duration: 0.7,
    },
  },
  exit: {
    x: " -100vw",
    transition: {
      ease: "easeInOut",
      delay: 0.5,
      duration: 1,
    },
  },
};
const Youtube = () => {
  return (
    <motion.section
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="blockPage"
    >
      <h2 className="blockPage__text">Choose witch one you want to discover</h2>
      <h3 className="blockPage__title">Language</h3>
      <Language />
      <h3 className="blockPage__title">Framework</h3>
      <Framework />
    </motion.section>
  );
};

export default Youtube;
